<template>
  <div>
    <!-- 信息维护 -->
    <div class="body">
      <div class="tbas">
        <div class="left">
          <!-- 待绑定管理番号 -->
          <div class="item" :class="{ choice: content == 'toBindManagementNumber' }"
            @click="setContent('toBindManagementNumber')">
            {{ $t('message.toBindManagementNumber') }}
          </div>
          <!--  数据维护-->
          <div class="item" :class="{ choice: content == 'dataMaintenance' }" @click="setContent('dataMaintenance')">
            {{ $t('message.dataMaintenance') }}
          </div>
          <!-- 审核列表 -->
          <div class="item" :class="{ choice: content == 'auditList' }" @click="setContent('auditList')">
            审核列表
          </div>
        </div>
        <div class="right">
          <!--  无需维护商品-->
          <el-button :type="content == 'noNeedToMaintainTheProduct' ? 'primary' : ''"
            @click="setContent('noNeedToMaintainTheProduct')">
            {{ $t('message.noNeedToMaintainTheProduct') }}
          </el-button>
        </div>
      </div>
      <!--无需维护商品  -->
      <noNeedToMaintainTheProduct v-if="content == 'noNeedToMaintainTheProduct'" />
      <!-- 待绑定管理番号 -->
      <toBindManagementNumber v-if="content == 'toBindManagementNumber'" />
      <!-- 数据维护 / 审核列表 -->
      <dataMaintenance v-if="content == 'dataMaintenance' || content == 'auditList'" :key="content"
        :audit-mode="content == 'auditList'" />
    </div>
  </div>
</template>
<script>
import noNeedToMaintainTheProduct from './components/noNeedToMaintainTheProduct'
import toBindManagementNumber from './components/toBindManagementNumber'
import dataMaintenance from './components/dataMaintenance'
export default {
  components: {
    noNeedToMaintainTheProduct,
    toBindManagementNumber,
    dataMaintenance
  },
  data() {
    return {
      content: this.$route.query.type ? this.$route.query.type : 'dataMaintenance',
    };
  },
  methods: {
    setContent(val) {
      this.content = val;
    },
  }
}
</script>
<style lang='scss' scoped>
.tbas {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  padding-bottom: 4px;
  margin-bottom: 16px;

  .left {
    display: flex;

    .item {
      padding: 12px 0;
      cursor: pointer;
      border-radius: 4px;
      margin-right: 46px;
      font-weight: bold;
      font-size: 16px;
    }

    .choice {

      color: #B4272D;
    }
  }
}
</style>
